import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import * as motion from "motion/react-client"
import { Step1Styles } from './Style'
import { Img } from 'styles/GlobalStyle'
import { StepOne1, StepOne2, Butterfly3, Butterfly2, Butterfly1, Sun, PathOne } from 'assets'
import { PerformAssessmentContext } from './PerformAssessmentContext'
import { statuses } from 'keys'
import { isBoolean, isEmpty } from 'lodash'
import { AnimatePresence } from "motion/react"
import { IconButton } from '@mui/material'
import { Pause, PlayArrow } from '@mui/icons-material'
import { useSelector } from 'react-redux'
import { screen_1_short_introduction_male, screen_1_short_introduction_female, screen_1_introduction_male, screen_1_introduction_female } from 'introductions'
import { _screen_1_short_introduction_male, _screen_1_short_introduction_female, _screen_1_introduction_male, _screen_1_introduction_female } from 'introductions/highGrades'
import NextButton from './NextButton'
import ReactPlayer from 'react-player';
import TooltipMessage from './Tooltip'
import tooltips from './utils/tooltips'

const Step1 = () => {
    const { testTaker = {} } = useSelector(state => state.testTaker)

    const { isQuestionAssessment, isLoading, isHighGrade, sessionExpired, assessments, setCurrentStep, isMaleGender, showNextButton, isFirstAssessment } = useContext(PerformAssessmentContext)

    const [cartoonSpeaking, setCartoonSpeaking] = useState(true)
    const [shouldAnimate, setShouldAnimate] = useState(false)

    const unCompleteIndex = useRef()
    unCompleteIndex.current = assessments?.findIndex(ass => ass.status == statuses.created || ass.status == statuses.brokenFile)

    const testTakersExpiration = JSON.parse(localStorage.getItem("children-process-expired"))
    const testTakerRef = useRef(testTaker);

    // עבור השכבות הנמוכות
    const shortStartAudio = isMaleGender ? screen_1_short_introduction_male : screen_1_short_introduction_female
    const startAudio = isMaleGender ? screen_1_introduction_male : screen_1_introduction_female

    // עבור השכבות הגבוהות
    const _shortStartAudio = isMaleGender ? _screen_1_short_introduction_male : _screen_1_short_introduction_female
    const _startAudio = isMaleGender ? _screen_1_introduction_male : _screen_1_introduction_female

    const otherTooltipMessage = isMaleGender ? tooltips.other_start_m : tooltips.other_start_f
    const firstTooltipMessage = isMaleGender ? tooltips.start_m : tooltips.start_f

    const lowGradesAudio = sessionExpired ? startAudio : shortStartAudio
    const highGradesAudio = sessionExpired ? _startAudio : _shortStartAudio

    let item = {
        path: PathOne,
        cartoonGif: StepOne1,
        cartoon: StepOne2,
        marginRight: 595,
        width: 1000,
        height: 300,
        autoNextStep: true,
        audio: isHighGrade ? highGradesAudio : lowGradesAudio,
        tooltip: isBoolean(sessionExpired) ? (sessionExpired ? firstTooltipMessage : otherTooltipMessage) : null
    }

    const handleCartoonSpeaking = useCallback(() => {
        setCartoonSpeaking(cartoonSpeaking => !cartoonSpeaking)
    }, [])

    const goNextStep = useCallback(() => {
        setCartoonSpeaking(false)
        setShouldAnimate(true);

        // ביצוע של מבדק ראשון בסט ביצועים מחייב בדיקת מקירופון
        if (isFirstAssessment)
            setCurrentStep(1)
        // ממבדק שני ואילך אנחנו מדלגים על בדיקת המיקרופון 
        else setCurrentStep(2)

    }, [isHighGrade, isQuestionAssessment])

    const onEndedPlayer = useCallback(() => {
        item.autoNextStep && !isHighGrade && goNextStep()
    }, [item, isHighGrade])

    useEffect(() => {
        testTakerRef.current = testTaker
    }, [testTaker])

    useEffect(() => {
        return (() => {
            const testTaker = testTakerRef.current
            if (!isEmpty(testTaker)) {
                const now = new Date();
                const expirationTime = now.getTime() + 24 * 60 * 60 * 1000; // 1 day in milliseconds
                const testTakerExpiration = {
                    [testTaker.test_taker_id]: expirationTime
                }
                if (sessionExpired) {
                    if (testTakersExpiration != null) {
                        localStorage.setItem("children-process-expired", JSON.stringify({ ...testTakersExpiration, ...testTakerExpiration }))
                    }
                    else {
                        localStorage.setItem("children-process-expired", JSON.stringify(testTakerExpiration))
                    }
                }
            }
        })
    }, [])

    return (
        <Step1Styles pathWidth={item.width} pathHeight={item.height} cartoonMarginRight={item.marginRight}>
            {isEmpty(assessments) ||
                <React.Fragment>
                    <div className='wrap-sun'>
                        {!shouldAnimate ? (
                            <motion.div
                                exit={{ opacity: 0 }}
                                initial={{ opacity: 0 }}
                                animate={shouldAnimate ? { opacity: 0 } : { opacity: 1 }} // אם shouldAnimate true, מתחילים להיעלם
                                transition={{ duration: 0.7 }}
                                className='sun'
                                key="sun"
                            >
                                <div className='sun'>
                                    <Img src={Sun} />
                                </div>
                            </motion.div>)
                            : null}
                    </div>
                    {!shouldAnimate ? (
                        <motion.div
                            exit={{ opacity: 0 }}
                            initial={{ opacity: 0 }}
                            animate={shouldAnimate ? { opacity: 0 } : { opacity: 1 }} // אם shouldAnimate true, מתחילים להיעלם
                            transition={{ duration: 0.7 }}
                            className='butterfly1'
                            key="butterfly1"
                        >
                            <Img src={Butterfly1} />
                        </motion.div>) : null}
                    {!shouldAnimate ? (
                        <motion.div
                            exit={{ opacity: 0 }}
                            initial={{ opacity: 0 }}
                            animate={shouldAnimate ? { opacity: 0 } : { opacity: 1 }} // אם shouldAnimate true, מתחילים להיעלם
                            transition={{ duration: 0.7 }}
                            className='butterfly2'
                            key="butterfly2"
                        >
                            <Img src={Butterfly2} />
                        </motion.div>) : null}
                    {!shouldAnimate ? (
                        <motion.div
                            exit={{ opacity: 0 }}
                            initial={{ opacity: 0 }}
                            animate={shouldAnimate ? { opacity: 0 } : { opacity: 1 }} // אם shouldAnimate true, מתחילים להיעלם
                            transition={{ duration: 0.7 }}
                            className='butterfly3'
                            key="butterfly3"
                        >
                            <Img src={Butterfly3} />
                        </motion.div>) : null}
                    {isLoading ||
                        (isHighGrade ?
                            <TooltipMessage
                                cartoonSpeaking={cartoonSpeaking}
                                handleCartoonSpeaking={handleCartoonSpeaking}
                                tooltip={item.tooltip}
                            />
                            :
                            <React.Fragment>
                                {!shouldAnimate ? (
                                    <motion.div
                                        exit={{ opacity: 0 }}
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        transition={{ duration: 0.7 }}
                                        className='path-img'
                                        key="path"
                                    >
                                        <Img src={item.path} />
                                    </motion.div>) : null}
                                {!shouldAnimate ? (
                                    <div className='wrap-cartoon-img'>
                                        <motion.div
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            exit={{ opacity: 0 }}
                                            transition={{ duration: 0.7 }}
                                            className='cartoon-img'
                                            key="cartoon1"
                                        >
                                            <Img src={cartoonSpeaking ? item.cartoonGif : item.cartoon} />
                                            {item.hidePlayPause ||
                                                <div className='play-pause-cartoon'>
                                                    <IconButton onClick={handleCartoonSpeaking}>
                                                        {cartoonSpeaking ? <Pause color="thirdly" /> : <PlayArrow color="thirdly" />}
                                                    </IconButton>
                                                </div>}
                                        </motion.div>
                                    </div>) : null}
                            </React.Fragment>)
                    }
                    {isLoading ||
                        showNextButton &&
                        !shouldAnimate ? (
                        <motion.div
                            exit={{ opacity: 0 }}
                            initial={{ opacity: 0 }}
                            animate={shouldAnimate ? { opacity: 0 } : { opacity: 1 }} // אם shouldAnimate true, מתחילים להיעלם
                            transition={{ duration: 0.7 }}
                            key="next-btn"
                        >
                            <div className='wrap-fab-button'>
                                <NextButton finish={item.finish} action={goNextStep} />
                            </div>
                        </motion.div>) : null
                    }

                    <ReactPlayer
                        playing={cartoonSpeaking}
                        url={item.audio}
                        controls={true}
                        width='0px' height='0px'
                        onEnded={onEndedPlayer}
                    />
                </React.Fragment>
            }
        </Step1Styles>
    )
}

export default Step1
